"use strict";


import { _I_, defineSimpleTerm } from 'components/locs';


function __mkSynthTag( internal_name, color )  {
  const name = _I_(`ClassInfoUtil.SynthTag.${internal_name}`);
  return {  "category":"\0\0",  "category_name":"",
            internal_name,  name,  color  };
}


export function cmpClassInfoTagValue( left, right )  {
  if (left.internal_name == right.internal_name)      return  0;
  if (left.internal_name <  right.internal_name)      return -1;
                                                      return  1;
}


export function cmpClassInfoTagCategory( left, right )  {
  if (left.category == right.category)      return  0;
  if (left.category <  right.category)      return -1;
                                            return  1;
}


export function cmpClassInfoTagCategoryValue( left, right )  {
  return cmpClassInfoTagCategory( left, right ) || cmpClassInfoTagValue( left, right );
}


export function fetchExtendedTags( classInfo )  {
  let tags = [ ...(classInfo.tags || []) ];

/*  // Disabled by intention
  const marketable = classInfo.marketable ? "1" : "0";
  tags.push(__mkSynthTag( `marketable${marketable}`,  "6770d5" ));

  const tradable = classInfo.tradable ? "1" : "0";
  tags.push(__mkSynthTag( `tradable${tradable}`,  "67d5b4" ));

  const commodity = classInfo.commodity ? "1" : "0";
  tags.push(__mkSynthTag( `commodity${commodity}`,  "93d567" ));

  // FIXME: tagify classInfo.contained_item
//  */

  return tags;
}


export function isExpired( classInfo )  {
    if ( classInfo.IS_UNRESOLVED )  {
      return false;
    }
    if ( !classInfo.marketable )
      return true;

    const expireAt = +classInfo.expireAt;
    const expireAtStamp = (!!expireAt) && (expireAt > 0) && +(new Date(1000*expireAt));

    if (expireAtStamp)  {
      const ensureHidden = 5*60*1000;
      const now = Date.now();
      if ( (expireAtStamp-ensureHidden) < now )
        return true;
    }

    return false;
}

export function isCountryDenied( classInfo ) {
  const userCountry = SettingsInjections.getCredentials().country;
  const deniedCountriesTag = fetchExtendedTags(
        classInfo
      ).filter(
        tagDesc  =>  tagDesc && tagDesc.category == 'countryDenyPurchase' && tagDesc.internal_name
      );
  const deniedCountries = deniedCountriesTag.length && deniedCountriesTag[0].internal_name.split('_');
  const countryDenied = deniedCountries && deniedCountries.filter(
    denyCountry => denyCountry && denyCountry.toUpperCase() == userCountry
  ).length;

  return !!countryDenied;
}


export function fakeClassInfo( reason,  name )  {
  return  {
    "name"                : `${_I_(`ClassInfoUtil.fake_name.${reason}`)} <${name}>`,
    "background_color"    : "",
    "name_color"          : "",
    "icon_url"            :  _I_(`ClassInfoUtil.fake_icon_url.${reason}`),
    "IS_UNRESOLVED"       : (reason=="broken"),
  };
}


// move out to separate l10n source
defineSimpleTerm( "ClassInfoUtil.fake_icon_url.pending",  "images/loader.gif",       {} );
defineSimpleTerm( "ClassInfoUtil.fake_icon_url.broken",   "images/broken_item.png", {} );

defineSimpleTerm( "ClassInfoUtil.fake_name.pending",  "Pending",       {
    "ru_RU": "загрузка",
    "cs_CZ": "Pending",
    "fr_FR": "En attente",
    "de_DE": "Ausstehend",
    "it_IT": "In sospeso",
    "ko_KR": "대기중",
    "pl_PL": "W trakcie",
    "pt_PT": "Pending",
    "es_ES": "Pendiente",
    "zh_CN": "等待中",
    "zh_TW": "等待中"
} );

defineSimpleTerm( "ClassInfoUtil.fake_name.broken",   "Deleted item ", {
    "ru_RU": "Удаленный предмет",
    "cs_CZ": "Deleted item",
    "fr_FR": "Item supprimé",
    "de_DE": "Gelöschtes Item",
    "it_IT": "Oggetti cancellati",
    "ko_KR": "아이템 삭제",
    "pl_PL": "Usunięte przedmioty",
    "pt_PT": "Deleted item",
    "es_ES": "Articulo eliminado",
    "zh_CN": "已删除物品",
    "zh_TW": "已刪除物品"
} );

defineSimpleTerm( "ClassInfoUtil.SynthTag.marketable1",  "Marketable",       {
    "ru_RU": "Можно продать",
    "cs_CZ": "Marketable",
    "fr_FR": "Commercialisable",
    "de_DE": "Marktfähig",
    "it_IT": "Vendibile",
    "ko_KR": "거래 가능 물품",
    "pl_PL": "Można sprzedać",
    "pt_PT": "Marketable",
    "es_ES": "Vendible",
    "zh_CN": "可在交易所交易",
    "zh_TW": "可在交易所交易"
} );
defineSimpleTerm( "ClassInfoUtil.SynthTag.marketable0",  "Non-marketable",   {
    "ru_RU": "Нельзя продать",
    "cs_CZ": "Non-marketable",
    "fr_FR": "Non commercialisable",
    "de_DE": "Nicht marktfähig",
    "it_IT": "Non vendibile",
    "ko_KR": "거래 불가능 물품",
    "pl_PL": "Nie można sprzedać",
    "pt_PT": "Non-marketable",
    "es_ES": "No vendible",
    "zh_CN": "不可在交易所交易",
    "zh_TW": "不可在交易所交易"
} );
defineSimpleTerm( "ClassInfoUtil.SynthTag.tradable1",    "Tradable",         {
    "ru_RU": "Можно обмениваться",
    "cs_CZ": "Tradable",
    "fr_FR": "Négociable",
    "de_DE": "Handelbar",
    "it_IT": "Scambiabile",
    "ko_KR": "거래 가능 물품",
    "pl_PL": "Można wymienić",
    "pt_PT": "Tradable",
    "es_ES": "Negociable",
    "zh_CN": "可交易",
    "zh_TW": "可交易"
} );
defineSimpleTerm( "ClassInfoUtil.SynthTag.tradable0",    "Non-tradable",     {
    "ru_RU": "Нельзя обмениваться",
    "cs_CZ": "Non-tradable",
    "fr_FR": "Non négociable",
    "de_DE": "Nicht handelbar",
    "it_IT": "Non scambiabile",
    "ko_KR": "거래 불가능 물품",
    "pl_PL": "Nie można wymienić",
    "pt_PT": "Non-tradable",
    "es_ES": "No Negociable",
    "zh_CN": "不可交易",
    "zh_TW": "不可交易"
} );
defineSimpleTerm( "ClassInfoUtil.SynthTag.commodity1",   "Commodity",        {
    "ru_RU": "Массовый товар",
    "cs_CZ": "Commodity",
    "fr_FR": "Matériel modifiable",
    "de_DE": "Handeslware",
    "it_IT": "Prodotto",
    "ko_KR": "거래 가능 물품",
    "pl_PL": "Towar",
    "pt_PT": "Commodity",
    "es_ES": "Comodidad",
    "zh_CN": "商品",
    "zh_TW": "商品"
} );
defineSimpleTerm( "ClassInfoUtil.SynthTag.commodity0",   "Non-commodity",    {
    "ru_RU": "Штучный товар",
    "cs_CZ": "Non-commodity",
    "fr_FR": "Matériel non modifiable",
    "de_DE": "Keine Handelsware",
    "it_IT": "Non merce",
    "ko_KR": "거래 불가능 물품",
    "pl_PL": "Dobro niesurowcowe",
    "pt_PT": "Non-commodity",
    "es_ES": "No comodidad",
    "zh_CN": "非商品",
    "zh_TW": "非商品"
} );
